export default {
    'ERROR-GET-CAMPAIGNS-ADMIN': {
        'CAMPAIGN-NOT-FOUND': {
            // actionType: 'redirect',
            actionType: 'toast',
            message: {
                fr: "Aucune campagne trouvée.",
                en: 'No campaigns found.',
            },
            // redirectPath: '/no-campaigns-found',
        },
        'INVALID-ORGANIZATION-ID': {
            actionType: 'toast',
            message: {
                fr: "ID d'organisation invalide.",
                en: 'Invalid organization ID.',
            },
        },
    },
    'ERROR-DELETE-CAMPAIGN': {
        'CAMPAIGN-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            // redirectPath: '/campaign-not-found',
        },
        'CAMPAIGN-ALREADY-DELETED': {
            actionType: 'toast',
            message: {
                fr: "La campagne a déjà été supprimée.",
                en: 'The campaign has already been deleted.',
            },
        },
        'CANNOT-DELETE-CAMPAIGN': {
            actionType: 'toast',
            message: {
                fr: "Cette campagne ne peut pas être supprimée.",
                en: 'This campaign cannot be deleted.',
            },
        },
    },
    'ERROR-ARCHIVE-CAMPAIGN': {
        'CAMPAIGN-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            // redirectPath: '/campaign-not-found',
        },
        'CAMPAIGN-ALREADY-DELETED': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne est déjà archivée.",
                en: 'This campaign is already archived.',
            },
            redirectPath: '/campaign-already-archived',
        },
        'CANNOT-ARCHIVE-CAMPAIGN': {
            actionType: 'toast',
            message: {
                fr: "Cette campagne ne peut pas être archivée.",
                en: 'This campaign cannot be archived.',
            },
        },
        'CANNOT-ARCHIVE-CAMPAIGN-RELATIONS-ONGOING': {
            actionType: 'toast',
            message: {
                fr: "Cette campagne a des relations en cours et ne peut pas être archivée.",
                en: 'This campaign has ongoing relations and cannot be archived.',
            },
        },
    },
};
